// extracted by mini-css-extract-plugin
export default {"totalsContainer":"_totals_totalsContainer__91iEb"};